import * as VAD from "voice-activity-detection";
import audioActivity from "audio-activity";
import { initiateMic } from "../../../utils/sys_utils";
import {
  stopRecording,
  startRecording,
  addAudioLog,
  updateVoiceDetection,
  updatEnvNoiseDetection,
} from "./audioSlice";
import { multiAction } from "../../multiAction";
import { v4 as uuidv4 } from "uuid";
import { submitFlags } from "../../activityAsyncAction";

export function delayRecByLagTime() {
  return (dispatch, getState) => {
    const {
      audio: { lagTimeInSecs },
    } = getState();
    let timeOut = setTimeout(() => {
      dispatch(stopRecording());
      clearTimeout(timeOut);
    }, lagTimeInSecs * 1000);
  };
}

export function soundDetectionAndRecording() {
  return (dispatch, getState) => {
    initiateMic().then((stream) => {
      const audio = audioActivity(stream);
      // requestAnimationFrame(function draw() {
      //   console.log(audio.get());
      //   requestAnimationFrame(draw);
      // });
      let tempSoundArray = [];
      const cycle = 2;
      let interval = setInterval(() => {
        const {
          audio: { isAudioRecording },
        } = getState();

        console.log("this is from the sound", audio.get());
        //finding average sound per half secs
        if (tempSoundArray.length < cycle) {
          tempSoundArray.push(audio.get());
        } else {
          tempSoundArray = [];
        }
        if (tempSoundArray.length === cycle) {
          let avgSound =
            tempSoundArray.reduce((acc, value) => acc + value) / cycle;
          if (avgSound >= 0.08 && !isAudioRecording) {
            //console.log("recording sound")
            dispatch(startRecording());
            dispatch(updatEnvNoiseDetection(true));
          } else if (avgSound < 0.08 && isAudioRecording) {
            dispatch(delayRecByLagTime());
            dispatch(updatEnvNoiseDetection(false));
          }
        }
        const {
          timer: { examEnded },
        } = getState();
        if (examEnded) {
          audio.destroy();
          const tracks = stream.getTracks();
          tracks.forEach((track) => {
            track.stop();
          });
          clearInterval(interval);
        }
      }, 250);
    });
  };
}

export function logAudioDetection(logType, dataBlob) {
  return function (dispatch, getState) {
    const {
      timer: {
        times: { startTime },
      },
    } = getState();
    if (dataBlob.size > 0) {
      let audioLog = {
        id: uuidv4(),
        logType,
        saved: false,
        time: Date.now() - startTime,
        dataUrl: window.URL.createObjectURL(dataBlob),
      };

      dispatch(addAudioLog(audioLog));
      dispatch(submitFlags({ ...audioLog, dataBlob }));
      //logic to save data using
    }
  };
}

export function voiceDetection() {
  let audioContext;
  window.AudioContext = window.AudioContext || window.webkitAudioContext;

  return (dispatch, getState) => {
    initiateMic().then((stream) => {
      audioContext = new AudioContext();
      const {
        audio: { vadOptions, isAudioRecording },
      } = getState();

      var options = {
        ...vadOptions,
        onVoiceStart: function () {
          if (!isAudioRecording) {
            // dispatch(updateVoiceDetection(true))
            //console.log("voice Started recording");
            multiAction([updateVoiceDetection(true), startRecording()]);
          }
        },
        onVoiceStop: function () {
          // console.log("voice stop");
          dispatch(updateVoiceDetection(false));
        },
        onUpdate: function (val) {
          //console.log("this is from the voice",val)
          const {
            audio: { isAudioRecording, isVoiceDetected, isEnvNoiseDetected },
          } = getState();
          if (isAudioRecording && !isVoiceDetected && !isEnvNoiseDetected) {
            dispatch(delayRecByLagTime());
          }
        },
      };

      VAD(audioContext, stream, options);
    });
  };
}
